import moment from "moment-timezone";
import Modal from "../Modal";
import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import { sendGetRequest } from "../../utils";

const EmployeeRewardClaimed = ({ open, onClose, employee }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [claimedRewards, setClaimedRewards] = useState([]);

  const fetchEmployeeRatings = async () => {
    try {
      setIsLoading(true);
      const resp = await sendGetRequest(
        `employees/redeem-points?employee_id=${employee.id}`,
        true
      );
      const data = await resp.json();
      setClaimedRewards(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (employee && employee?.id) {
      setClaimedRewards([]);
      fetchEmployeeRatings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employee]);

  return (
    <Modal
      open={open}
      handleClose={onClose}
      style={{ width: "720px", backgroundColor: "#f5f5f5" }}
    >
      <div className="flex flex-col gap-4">
        <h1 className="text-xl font-bold">Employee Points</h1>
        <div className="space-y-2">
          <TableContainer component={Paper} sx={{ maxHeight: "400px" }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className="!text-center">Type</TableCell>
                  <TableCell className="!text-center">Points</TableCell>
                  <TableCell className="!text-center">Name</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && (
                  <TableRow>
                    <TableCell colSpan={5} className="!text-center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                )}
                {claimedRewards.map((reward) => (
                  <TableRow key={reward.id}>
                    <TableCell className="!text-center capitalize">
                      {reward.type.replaceAll("_", " ")}
                    </TableCell>
                    <TableCell className="!text-center">
                      {reward.points}
                    </TableCell>
                    <TableCell className="!text-center">
                      {reward.name}
                    </TableCell>
                    <TableCell className="!text-center">
                      <div className="max-w-[120px] text-left">
                        {reward.description}
                      </div>
                    </TableCell>
                    <TableCell>
                      {moment(reward.created_at).format("YYYY-MM-DD")}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </Modal>
  );
};

export default EmployeeRewardClaimed;
